<template>
    <div id="app">
        <nav-bar></nav-bar>
        <div id='router-view'>
            <notifications></notifications>
            <keep-alive :include=this.isCached>
                <router-view/>
            </keep-alive>
        </div>
    </div>

</template>

<script>
    export default {
        name: "app",
        data() {
            return {
                mainProps: {
                    blank: true,
                    width:30,
                    height:30
                },
                isCached : ["Order"]
            }
        },
    };
</script>
<style>
    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        background-color: #F2F3F4;
        min-height: 100vh;
    }

    #router-view {
        padding: 20px 0px 100px;
        margin: 0 auto;
    }

</style>
